import PropTypes from 'prop-types';

import KitoBalloon from '../DataDisplay/Balloon';

import defaultBuddy from '../../assets/kitoBuddy/default.png';
import whatIs from '../../assets/kitoBuddy/what-is.png';
import whatToDo from '../../assets/kitoBuddy/what-to-do.png';
import whenToWorry from '../../assets/kitoBuddy/when-to-worry.png';
import asking1 from '../../assets/kitoBuddy/asking-1.png';
import asking2 from '../../assets/kitoBuddy/asking-2.png';
import wrong1 from '../../assets/kitoBuddy/wrong-1.png';
import wrong2 from '../../assets/kitoBuddy/wrong-2.png';
import celebration1 from '../../assets/kitoBuddy/celebration-1.png';
import celebration2 from '../../assets/kitoBuddy/celebration-2.svg';

import styles from './styles.module.css';

const BuddyImages = Object.freeze({
  defaultBuddy,
  whatToDo,
  whatIs,
  whenToWorry,
  asking1,
  asking2,
  wrong1,
  wrong2,
  celebration1,
  celebration2
});

function KitoBuddy({ image = 'defaultBuddy', children, mascotWidth = 120, textVariant, stretch = false, ...rest }) {
  return (
    <div className={styles.KitoBuddy} data-stretch={stretch} {...rest}>
      <img width={mascotWidth} src={BuddyImages[image]} alt="kito-mascot-1" />
      {children && <KitoBalloon marginLeft="-var(--spacing-m)" textVariant={textVariant}>{children}</KitoBalloon>}
    </div>
  );
}

KitoBuddy.propTypes = {
  image: PropTypes.oneOf(Object.keys(BuddyImages)),
  children: PropTypes.node,
  speech: PropTypes.bool,
  title: PropTypes.bool,
  rest: PropTypes.object,
  mascotWidth: PropTypes.number,
  stretch: PropTypes.bool,
  textVariant: PropTypes.oneOf(['default', 'title']),
};

export default KitoBuddy;
